import template from './needsAndObjectivesBankruptcy.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    bankruptcy: '<',
    contacts: '<',
    index: '<',
    validationErrors: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, helperService, dateTimeService) {
      'ngInject';

      const ctrl = this;
      ctrl.availableYesNoOptionTwo = [];
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;

      ctrl.initialize = () => {
        ctrl.bankruptcy = ctrl.bankruptcy || {};
        ctrl.contacts = ctrl.contacts || [];
        ctrl.index = ctrl.index !== undefined ? ctrl.index : -1;
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.availableYesNoOptionTwo = helperService.getAvailableYesNoOptions({
          option: 2
        });
        dateTimeService.getSet(ctrl, ctrl.bankruptcy, 'dischargedDate', 'getSetDischargedDate');
      };

      ctrl.toggleBankruptcy = () => {
        ctrl.bankruptcy.comments = '';
        ctrl.bankruptcy.dischargedDate = 0;
        // eslint-disable-next-line no-underscore-dangle
        ctrl.__getSetDischargedDate = '';
        ctrl.saveBankruptcy();
      };

      ctrl.getContact = (idContact) =>
        helperService.getContact({ contacts: ctrl.contacts, idContact });

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveBankruptcy = () => {
        ctrl.onFinished({ bankruptcy: ctrl.bankruptcy });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
